// Shapes of the IDL-derived layouts (see idl-layout.ts, generated by scripts/sync-idl.ts).

export type ArgType = "u8" | "u16" | "u32" | "u64" | "i64" | "bool" | "pubkey" | { option: ArgType };

export interface AccountLayout {
  name: string;
  writable?: boolean;
  signer?: boolean;
  optional?: boolean;
  /** Fixed address (programs/sysvars); builders fill it in automatically. */
  address?: string;
}

export interface InstructionLayout {
  name: string;
  accounts: readonly AccountLayout[];
  args: readonly { name: string; type: ArgType }[];
}

export type FieldType = "u8" | "u64" | "i64" | "bool" | "pubkey";

export interface AccountDataLayout {
  name: string;
  fields: readonly { name: string; type: FieldType }[];
}

const FIELD_SIZES: Record<FieldType, number> = { u8: 1, bool: 1, u64: 8, i64: 8, pubkey: 32 };

/** Serialized size incl. the 8-byte discriminator (Borsh, no padding). */
export function accountSize(layout: AccountDataLayout): number {
  return 8 + layout.fields.reduce((n, f) => n + FIELD_SIZES[f.type], 0);
}
